import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { SuccessIcon } from 'foundations-assets';
import { Button } from 'foundations-components/transitional/components/Button';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const DisabledButtonTooltipCopy = ({
  upgradeProduct,
  conflictingTrial
}) => {
  if (conflictingTrial) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "upgrades.trialActivationButton.tooltip.disabledButtonConflict",
      options: {
        conflictingUpgradeProduct: I18n.text(`upgrades.products.${conflictingTrial}`)
      }
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "upgrades.trialActivationButton.tooltip.disabledButton",
    options: {
      upgradeProduct: I18n.text(`upgrades.products.${upgradeProduct}`)
    }
  });
};
const TrialActivationButtonWithTooltip = ({
  use,
  upgradeProduct,
  onClick,
  isTrialed,
  showActivationModalContainer,
  isLoading,
  trialI18nKey,
  children,
  conflictingTrial,
  block,
  dataSeleniumId
}) => {
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: !isTrialed && !conflictingTrial,
    placement: "bottom",
    title: /*#__PURE__*/_jsx(DisabledButtonTooltipCopy, {
      upgradeProduct: upgradeProduct,
      conflictingTrial: conflictingTrial
    }),
    children: use && use.includes('link') ? /*#__PURE__*/_jsx(Button, {
      use: use,
      onClick: onClick,
      "data-selenium": "trial-button",
      "data-test-id": "trial-button",
      disabled: isTrialed || !!conflictingTrial,
      block: block,
      "data-selenium-id": dataSeleniumId,
      children: children || /*#__PURE__*/_jsx(FormattedMessage, {
        message: trialI18nKey
      })
    }) : /*#__PURE__*/_jsx(LoadingButton, {
      use: use,
      onClick: onClick,
      "data-selenium": "trial-button",
      "data-test-id": "trial-loading-button",
      loading: showActivationModalContainer || isLoading,
      disabled: isTrialed || !!conflictingTrial,
      resultIcon: showActivationModalContainer ? SuccessIcon : undefined,
      block: block,
      "data-selenium-id": dataSeleniumId,
      children: children || /*#__PURE__*/_jsx(FormattedMessage, {
        message: trialI18nKey
      })
    })
  });
};
export default TrialActivationButtonWithTooltip;